import { Button, Col, Form, Image, Input, message, Modal, Row, Select, Switch } from 'antd'
import React, { useEffect, useState } from 'react'
import Applogo from './../../assets/aapaNewlogoTm.png';
import { CloseCircleOutlined, DownOutlined, LockOutlined, MailOutlined, MobileOutlined, SearchOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { countryCodes } from '../../data';
import axios from 'axios';
import { BE_HOST } from '../../config/config';
import { HandleOnclose } from '../../utils/hash';
import { useDispatch } from 'react-redux';
import newLogo from './../../assets/advant-logoTm.png';
import SmsoptModal from '../../components/smsoptModal/SmsoptModal';



const MobileAuth = () => {
  const location = useLocation()
  const email = location.state?.email;
  const mobile = location.state?.mobile;
  const dispatch = useDispatch()

  const [form] = Form.useForm();
  const navigate = useNavigate()
  const { Option } = Select;
  const [countryCode, setCountryCode] = useState("+1");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNo, setPhoneNo] = useState(mobile ? mobile : '');
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [btnActive, setBtnActive] = useState(true);
  const [otpInputActive, setOtpInputActive] = useState(true)
  const [searchText, setSearchText] = useState('')
  const [filteredCode, setFilteredCode] = useState('')
  const [acceptedTerms, setAcceptedTerms] = useState(true);
  const [smsModal,setSmsModal] = useState(false)


  const handleSendOTP = async (values) => {
    if(!acceptedTerms){
      message.error("Please enable SMS Opt-In to continue");
      return;
    }
    console.log("phoneNo", phoneNo);
    setIsLoading(true)
    const payload = {
      email: email || '',
      phone: `${countryCode}${values?.mobile}`,
    };

    try {
      // console.log(" Sending request...");
      const response = await axios.post(`${BE_HOST}/auth/add-phone`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: "Bearer yourAccessToken"
          }
        }
      );
      console.log("Response:", response.data);
      message.success(response?.data?.message)
      navigate('/otp', {
        state: { email: email, mobile: `${countryCode}${values?.mobile}`, active: true, flag: false }
      })
    } catch (error) {
      console.error("Add phone error:", error);
      const resData = error?.response?.data;

      if (resData?.step === "invalid_phone") {
        message.error(resData.message || "Invalid phone number.");
        navigate('/otp', {
          state: { email: email, mobile: `${countryCode}${values?.mobile}`, active: true }
        })
      } else {
        message.error(resData?.message || "Something went wrong.");
      }

    } finally {
      setIsLoading(false)
    }
  };


  // console.log(mobile,"mobileeees")
  useEffect(() => {
    if (mobile && mobile.startsWith("+")) {
      const matchedCode = countryCodes.find(code => mobile.startsWith(code.code));
      if (matchedCode) {
        setCountryCode(matchedCode.code);
        form.setFieldsValue({
          mobile: mobile.replace(matchedCode.code, "")
        });
      }
    } else {
      form.setFieldsValue({
        mobile: mobile
      })
    }

  }, [mobile, form]);

  useEffect(() => {
    const filtered = countryCodes.filter((code) =>
      code.code.includes(searchText)
    );
    setFilteredCode(filtered);
  }, [searchText, countryCode]);


  useEffect(() => {
  const handleClick = (event) => {
    const dropdown = document.getElementById("dropdown-box");
    const toggleBtn = document.getElementById("dropdown-toggle-btn");

    if (
      dropdown &&
      !dropdown.contains(event.target) &&
      toggleBtn &&
      !toggleBtn.contains(event.target)
    ) {
      setShowDropdown(false); // ✅ Close dropdown
    }
  };

  document.addEventListener("mousedown", handleClick);
  return () => {
    document.removeEventListener("mousedown", handleClick);
  };
}, []);

  return (
    <div className="min-h-screen bg-[#000833] flex flex-col items-center justify-center p-4">
      <div className='mb-2'>
      <Image
        style={{marginTop:"6px"}}
        src={Applogo}
        alt="AAPA Logo"
        preview={false}
        className=" rounded-md"
        width={160}
        height={140}
        />
        </div>
      <div style={{ position: "absolute", top: 20, right: 20, cursor: 'pointer', }} onClick={() => HandleOnclose(dispatch)}>
        <CloseCircleOutlined style={{ fontSize: 24, color: 'white' }} />
      </div>
      <div className="w-full max-w-[800px] flex flex-col items-center bg-[#000833] rounded-2xl
       border-[3px] border-white pb-20
       ">
        <Image
          style={{ marginTop: "28px", marginBottom: "28px" }}
          src={newLogo}
          alt="AAPA Logo"
          preview={false}
          className="mb-8"
          width={300}
        />
        <div className="w-full max-w-[470px] bg-[#000833] rounded-2xl border-[2px] border-white px-6 py-8 shadow-lg">
          <h2 className="text-2xl font-bold text-white mb-4 flex items-center justify-center gap-2">
            <MobileOutlined style={{ fontSize: 26, color: "#0EA5E9" }} />
            Enter Mobile Number
          </h2>

          <Form form={form} layout="vertical" onFinish={handleSendOTP}>
            <Form.Item style={{}}>
              <div className="flex w-full">
                <div className="relative">
                  <button
                    id="dropdown-toggle-btn"

                    type="button"
                    className="h-[44px] PX-3 MAX-W-[60px]  bg-white text-sm font-semibold text-black 
                  border-gray-300 border-r-0 flex items-center justify-center rounded-l-md rounded-r-none"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    {countryCode}
                    <DownOutlined className="ml-1 text-xs" />
                  </button>
                  {showDropdown && (
                    <div
                      id="dropdown-box"
                      className="absolute max-h-[200px] z-10 w-[200px] bg-white border border-gray-300 rounded-md mt-1 shadow-md overflow-y-auto no-scrollbar">
                      <div className="relative w-full ">
                        <Input
                          placeholder="Enter Code"
                          allowClear
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          size="small"
                          onKeyDown={(e) => {
                            if (e.key === "Backspace") {
                              e.stopPropagation();
                            }
                          }}
                          className="pr-6 text-xs rounded-sm bg-gray-100"
                        />
                        <SearchOutlined className="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 text-[12px]" />
                      </div>
                      {filteredCode?.map((item) => (
                        <div
                          key={item?.label}

                          className="px-3 py-2 hover:bg-blue-100 cursor-pointer text-sm flex items-center justify-start border-b last:border-b-0"
                          onClick={() => {
                            setCountryCode(item.code);
                            setShowDropdown(false);
                          }}
                        >
                          <span className="text-gray-500 w-[70px]">{item.code}</span>
                          <span className="font-medium text-gray-700 w-[130px]">{item.label}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <Form.Item
                  name="mobile"
                  noStyle
                  rules={[
                    { required: true, message: "Please enter your mobile number" },
                    // {
                    //   pattern: /^[6-9]\d{9}$/,
                    //   message: "Please enter a valid mobile number",
                    // },
                    {
                      validator(_, value) {
                        if (!value || (value.length >= 8 && value.length <= 14)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Please enter a valid mobile number")
                        );
                      }
                    }
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={15}
                    type='tel'
                    inputMode="numeric"
                    prefix={<MobileOutlined className="text-gray-400" />}
                    placeholder="Mobile Number"
                    className="h-[44px] w-full !border-l-0 !rounded-l-none rounded-r-md"
                  />
                </Form.Item>
              </div>
            </Form.Item>
            <Form.Item>
              <Button
                type={acceptedTerms ? "primary" : "default"}
                htmlType="submit"
                block
                loading={isLoading}
                size="large"
                // className={`h-[44px] rounded-md text-white `}
                disabled={!acceptedTerms}
                className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
                style={
                !acceptedTerms
                   ? {
                       backgroundColor: "#888c88",
                       borderColor: "#888c88",
                       color: "#222",
                       boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
                     }
                   : undefined
               }
              >
                Send OTP
              </Button>
            </Form.Item>
          </Form>

        </div>
        <div className="flex gap-2 mt-2 justify-end items-start w-full max-w-[470px] mb-3">
           <a
            onClick={()=>setSmsModal(true)}
             target="_blank"
             rel="noopener noreferrer"
             className="text-white underline hover:text-sky-400 text-[15px] font-semibold cursor-pointer"
           >
             SMS Opt In
           </a>
           <Switch
             checked={acceptedTerms}
             onChange={(checked) => {
              if(!checked){
                message.error("Please enable SMS Opt-In to continue");
                setAcceptedTerms(checked)
              }else{
                setAcceptedTerms(checked)
              }
            }}
             size="medium"
             style={{
               backgroundColor: acceptedTerms ? "#0092ba" : "#d1d5db",
             }}
           />
         </div>
        <div className="mb-2  flex justify-center items-start px-2 gap-2 text-white">
          <a
              href="https://myrxadvantedge.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline hover:text-blue-600 font-semibold"
            >
              Privacy Policy
            </a>
             | 
           <a
              href="https://myrxadvantedge.com/terms-of-service/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline hover:text-blue-600 font-semibold">
               Terms & Conditions
            </a>{" "}
        </div>
      </div>
      <SmsoptModal
        hide={() => setSmsModal(false)}
        visible={smsModal}
      />
      <style>
        {`
          .ant-message .ant-message-notice {
            padding: 16px 24px;
          }

          .ant-message .ant-message-notice-content {
            font-size: 24px;
            min-height: 50px;
            display: flex;
            align-items: center;
          }
          .no-scrollbar::-webkit-scrollbar {
            display: none;
          }

          .no-scrollbar {
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none;    /* Firefox */
          }

        `}
      </style>
    </div>
  )
}

export default MobileAuth

